module.exports = __webpack_public_path__ + "img/ota.5f4a600c.png";